import React from 'react';

import { FaRegFileAlt } from 'react-icons/fa';

import { useToggle } from 'utils/hooks/useToggle';

import TestResultModal from '../TestResultModal';

import './test-result.scss';

const TestResult = () => {
  const [displayTestResult, setDisplayTestResult] = useToggle();

  return (
    <section className="test-result">
      <FaRegFileAlt size={24} color="#9b2c51" onClick={setDisplayTestResult} />
      {displayTestResult && <TestResultModal modalIsOpen={displayTestResult} toggleModal={setDisplayTestResult} />}
    </section>
  );
};

export default TestResult;
